module.exports = __webpack_public_path__ + "static/img/female-factory-640w.0c75423.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/female-factory-640w.jpeg
// module id = 218
// module chunks = 5